import React, { useRef, useState } from 'react';
import type { FC } from 'react';
import classnames from 'classnames';

import { useIntersectionObserver } from 'usehooks-ts';
import { useTranslation } from '@lt/localization';

// Components:
import { ButtonTs } from '@lt/components';

import styles from './countryList.mobile.module.css';

// Models:
import type { ICountryListMobile } from './Models/country-list.model';

export const CountryListMobile: FC<ICountryListMobile> = (props) => {
  const {
    className,
    linkedCountryList,
    linkedCountryListTitle,
    trackCountryLinkClick,
    trackCountryListExpand,
  } = props;

  const { t } = useTranslation();

  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {
    freezeOnceVisible: true,
  });
  const isVisible = !!entry?.isIntersecting || !linkedCountryListTitle;

  const [showAll, setShowAll] = useState(false);
  const handleShowMore = () => {
    trackCountryListExpand();
    setShowAll(!showAll);
  };

  let listCountOffset = linkedCountryList.length;
  const mobileCountOffset = 6;
  listCountOffset = showAll ? linkedCountryList.length : mobileCountOffset;

  return (
    <div
      className={classnames({
        [styles.containerWhite]: !linkedCountryListTitle,
      })}
    >
      {!!linkedCountryListTitle && (
        <h2 className={styles.name}>{linkedCountryListTitle}</h2>
      )}
      <div className={classnames(styles.countryList, className)} ref={ref}>
        {linkedCountryList.map((item, index) => {
          const { link, text, iso2 } = item;

          return index < listCountOffset ? (
            <div className={styles.listItem} key={`${link}`}>
              {isVisible && (
                <div
                  className={classnames(
                    'lt-flag',
                    `lt-flag-${iso2?.toLowerCase() || 'us'}`,
                  )}
                />
              )}
              <a
                className={styles.anchor}
                href={link}
                onClick={() => trackCountryLinkClick(iso2)}
              >
                {text}
              </a>
            </div>
          ) : null;
        })}
      </div>
      {!showAll ? (
        <ButtonTs
          className={styles.showMore}
          variant="functional"
          onClick={handleShowMore}
        >
          {t('explore.links.coutryList.showMoreButton')}
        </ButtonTs>
      ) : null}
    </div>
  );
};
